import getDpAnalytics from '@webapp-next/lib/facades/get-dp-analytics';

/**
 * @deprecated Please use `get-data-analytics`
 *
 * @typedef Event
 * @type {object}
 * @property {string} name - the event name.
 * @property {string} screen - the screen/module where the event is being triggered.
 *  Important: it must be a key of EventName enum.
 * @property {string} source - the component that triggers the event.
 *  Important: it must be a key of EventScreen enum.
 * @property {object} [data] - any additional data specific to the event.
 */

const dpAnalytics = getDpAnalytics() ?? {};

const ViewTypes =
  dpAnalytics?.root?.lookupEnum(
    'deputy.data.analytics.event.data.view.ViewType'
  )?.values || {};

function getEventView({ name, type, interaction, results, url }) {
  const View = dpAnalytics.root.lookupType(
    'deputy.data.analytics.event.data.view.View'
  );
  const Details = dpAnalytics.root.lookupType(
    'deputy.data.analytics.event.data.view.Details'
  );
  const details = Details.ctor.create({
    name,
    url,
    type,
    results,
    interaction,
  });
  const view = View.ctor.create({
    details,
  });

  return view;
}

/**
 * Tracks a user event.
 *
 * @param {Event} event
 * @return {void}
 */
function trackEvent({ name, screen, source, data }) {
  const { EventScreen, EventName } = dpAnalytics;

  if (!EventName || !EventScreen) {
    throw new Error('dpAnalytics is not available');
  }

  if (!EventName.hasOwnProperty(name)) {
    throw new Error('Invalid EventName value provided');
  }

  if (!EventScreen.hasOwnProperty(screen)) {
    throw new Error('Invalid EventScreen value provided');
  }

  dpAnalytics.sendAnalyticEvent(
    EventName[name],
    EventScreen[screen],
    event => ({
      ...event,
      ...data,
      source,
    })
  );
}

export { trackEvent, ViewTypes, getEventView };
